<template>
  <!-- Search Bar -->
  <div class="relative flex items-center w-full">

    <!-- Search Input -->
    <input
      type="text"
      name="search"
      v-model="search"
      :placeholder="placeholder"
      value=""
      class="w-full py-3 text-gray-600 placeholder-gray-600 border border-gray-500 placeholder-uppercase focus:placeholder-opacity-0 focus:normal-case focus:border-gray-500 focus:ring-transparent"
      >

    <!-- Search Icon -->
    <span class="absolute right-4">
      <svg class="w-6 h-6 text-purple-500 fill-current">
        <title>Search Icon</title>
        <use :xlink:href='svgSpriteUrl + "#icon-search"'></use>
      </svg>
    </span>

  </div>
</template>

<script>

export default {
  props: {
    placeholder: ''
  },
  computed: {
    search: {
      get () {
        return this.$store.state.search
      },
      set (value) {
        this.$store.commit('setSearch', value)
      }
    },
    svgSpriteUrl() {
      return tofinoJS.themeUrl + '/dist/svg/sprite.symbol.svg';
    }
  },
};
</script>
